import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/style.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Home: React.FC = () => {
  const slideRef = useRef<HTMLImageElement[]>([]);
  useEffect(() => {
    let currentSlide = 0;
    const slides = slideRef.current;
    function showSlide(index: number) {
      slides.forEach((slide, i) => {
        if (slide) slide.classList.toggle("active", i === index);
      });
    }
    const interval = setInterval(() => {
      if (slides.length === 0) return;
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Galeri resim dosyaları (artık dinamik)
  const [randomGalleryImages, setRandomGalleryImages] = useState<string[]>([]);

  useEffect(() => {
    fetch('/galleryImages.json')
      .then(res => res.json())
      .then((files: string[]) => {
        // 6 tane rastgele seç
        const shuffled = files.slice().sort(() => 0.5 - Math.random());
        setRandomGalleryImages(shuffled.slice(0, 6).map(name => `/imageGallery/${name}`));
      });
  }, []);

  const [headerImages, setHeaderImages] = useState<string[]>([]);

  useEffect(() => {
    fetch('/headerImages.json')
      .then(res => res.ok ? res.json() : [])
      .then((files: string[]) => setHeaderImages(files))
      .catch(() => setHeaderImages([]));
  }, []);

  return (
    <>
      <header className="hero">
        <div className="slider">
          {(headerImages.length ? headerImages : ["header.jpg", "header2.jpg", "header(1).jpg", "header(2).jpg", "header(3).jpg", "header(4).jpg"]).map((img, i) => (
            <img
              key={img}
              src={`/images/${img}`}
              className={`slide${i === 0 ? " active" : ""}`}
              ref={el => {
                if (el) slideRef.current[i] = el;
              }}
              alt="Header Slide"
            />
          ))}
        </div>
        <Navbar />
        <div className="hero-content">
          <h1><span className="trade-winds-regular">Tim Elektrik</span><br />Dekorasyon ve Uygulama</h1>
          <p>olarak 2005 yılından beri yanınızdayız.</p>
          <Link to="/services" className="button">Hizmetlerimiz →</Link>
        </div>
      </header>
      <section className="about">
        <h2>Bizi daha yakından tanıyın</h2>
        <p>
          2005 yılından bu yana, Tim Elektrik Dekorasyon ve Uygulama olarak sektördeki güçlü duruşumuzu her geçen gün daha da pekiştiriyoruz. Kurulduğumuz günden itibaren kalite, güven ve müşteri memnuniyetini temel ilke edindik. Elektrik ve dekorasyon alanındaki tecrübemizi, sürekli gelişen teknoloji ve yenilikçi çözümlerle birleştirerek her projede fark yaratmayı hedefliyoruz.
        </p>
      </section>
      <section className="services">
        <div className="service-card">
          <h3>Elektrik Bölümü</h3>
          <ul>
            <li>Bahçe Aydınlatma</li>
            <li>Elektrik Kablo Döşeme</li>
            <li>Elektrik Tesisatı Döşeme</li>
            <li>Aydınlatma</li>
          </ul>
          <Link to="/services" className="button">Hizmetlerimiz →</Link>
        </div>
        <div className="service-card">
          <h3>Alt Yapı ve Kablolama</h3>
          <ul>
            <li>Cat5e, Cat6e, Cat6a, Cat7 UTP –</li>
            <li> FTP ve Fiber Optik kablolama </li>
            <li>uygulamaları ve profesyonel altyapı </li>
            <li>hizmeti vermekteyiz.</li>
          </ul>
          <Link to="/services" className="button">Hizmetlerimiz →</Link>
        </div>
        <div className="service-card">
          <h3>CCTV, Ip ve Telefon</h3>
          <ul>
            <li>IP CCTV kameralı güvenlik sistemi </li>
            <li> alt yapı kurulumu ve</li>
            <li>sistem devreye alma hizmeti</li>
            <li>veriyoruz.</li>
          </ul>
          <Link to="/services" className="button">Hizmetlerimiz →</Link>
        </div>
      </section>
      <section className="video-section">
        <div className="video-container">
          <video 
            className="hero-video"
            controls
            autoPlay
            loop
            muted
            playsInline
          >
            <source src="/video/promotional-video.mp4" type="video/mp4" />
            <source src="/video/promotional-video.webm" type="video/webm" />
            Tarayıcınız video oynatmayı desteklemiyor.
          </video>
        </div>
      </section>
      <section className="home-gallery-preview">
        {randomGalleryImages.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`Galeri Önizleme ${i+1}`}
            className="home-gallery-preview-img"
          />
        ))}
      </section>
      <div className="gallery-button">
        <Link to="/gallery" className="gal-button">Galeri →</Link>
      </div>
      <Footer />
    </>
  );
};

export default Home; 